import { useEffect, useState } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';

import UserProfileForm from '../../Profile/UserProfileForm';
import Loading from '../../../Shared/Components/Loading';
import { error, success } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { baseApiUrl } from '../../../Shared/utils/helper';
import Master from '../../Layouts/Master';

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [photoIds, setPhotoIds] = useState([]);
  const [insuranceIds, setInsuranceIds] = useState([]);

  useEffect(() => {
    getInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getInfo = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/user/${id}`,
      {},
      (res) => {
        setUser(res.data.data);
        setLoading(false);
      },
      () => {
        error('هنگام دریافت اطلاعات کاربر خطایی رخ داده است.');
        setLoading(false);
        navigate('/panel/admin/users', { replace: true });
      },
    );
    await useApi.get(
      '/user/portal/provinces',
      {},
      (res) => {
        setProvinces(res.data.data);
      },
      () => {
        error('هنگام دریافت استان‌ها خطایی رخ داده است.');
      },
    );
    await useApi.get(
      '/general/country',
      {},
      (res) => {
        setCountries(res.data.data || []);
      },
      () => {
        error('هنگام دریافت کشورها خطایی رخ داده است.');
      },
    );
  };

  const onSubmitForm = async (values) => {
    setSubmitFormLoading(true);

    if (photoIds.length > 0) {
      const photoId = photoIds[0].serverId;
      const thumbnail = JSON.parse(photoId);
      values.personnel_image = thumbnail.data.personnel_image;
    }

    if (insuranceIds.length > 0) {
      const insuranceId = insuranceIds[0].serverId;
      const uploaded = JSON.parse(insuranceId);
      values.insurance_image = uploaded.data.insurance_image;
    }

    if (!values.password) {
      delete values.password;
    }

    await useApi.put(
      `/panel/user/${id}`,
      values,
      () => {
        success('اطلاعات کاربر با موفقیت ویرایش شد');
        setSubmitFormLoading(false);
        getInfo();
      },
      (err) => {
        const errors = err?.data?.errors;
        if (errors) {
          Object.values(errors).forEach((messages) => error(messages[0]));
        } else {
          error('خطایی در ثبت اطلاعات پیش آمده است.');
        }
        setSubmitFormLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master title='ویرایش کاربر'>
      <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-2 my-3'>
        <div className='d-flex flex-row align-items-center'>
          <i className='fad fa-user-edit f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            ویرایش کاربر — {user?.name} {user?.last_name}
          </h1>
        </div>
        <Link to='/panel/admin/users' className='btn btn-outline-secondary f-13'>
          بازگشت به لیست
        </Link>
      </div>
      <UserProfileForm
        user={user}
        provinces={provinces}
        countries={countries}
        onSubmit={onSubmitForm}
        submitLoading={submitFormLoading}
        photoIds={photoIds}
        setPhotoIds={setPhotoIds}
        insuranceIds={insuranceIds}
        setInsuranceIds={setInsuranceIds}
        uploadProfileUrl={`${baseApiUrl()}/panel/user/${id}/upload/profile`}
        uploadInsuranceUrl={`${baseApiUrl()}/panel/user/${id}/upload/insurance`}
      />
    </Master>
  );
};

export default EditUser;
